module.exports = __webpack_public_path__ + "static/media/ad_notification.12a9adce.PNG";